import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';

// Confirmed against the real admin-side broadcast endpoint (see
// broadcast-v2.component.ts's mapBroadcastDetail, which reads the same
// broadcastMediaList shape) — broadcastMediaType is "IMAGE" or a document
// type, and broadcastMediaUrl is the actual file URL.
export interface BroadcastMedia {
  broadcastMediaType: string;
  broadcastMediaUrl: string;
  [key: string]: any;
}

export interface BroadcastItem {
  broadcastId: number;
  isRead: boolean;
  broadcastMediaList: BroadcastMedia[];
  broadcastSubject: string;
  broadcastMessage: string;
  sentOnDate: string;
  sentOnTime: string;
}

export interface BroadcastListBody {
  broadcastDetail: BroadcastItem[];
  maxPageNumber: number;
  unreadCount: number;
}

export type BroadcastReadFilter = 'ALL' | 'UNREAD';

// Broadcast — parent mobile app's own V2 list (BrodcastListView.js). The
// legacy BroadcastDetailedView.js/broadCastSubject-cased response shape is
// NOT connected to this list anymore (per the API reference this was built
// from) — only the V2 broadcastSubject/broadcastMessage shape below is
// current.
@Injectable({ providedIn: 'root' })
export class ParentBroadcastService {

  private base = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders | undefined {
    const raw = localStorage.getItem('authToken');
    if (!raw) { return undefined; }
    try {
      return new HttpHeaders().append('authToken', JSON.parse(raw));
    } catch {
      return new HttpHeaders().append('authToken', raw);
    }
  }

  getBroadcastMessages(academicId: string, readStatus: BroadcastReadFilter, search: string, pageNumber: number, pageLimit: number) {
    return this.http.post(`${this.base}/get/broadcast/messages/parent`, {
      academicId,
      receiverType: null,
      readStatus: readStatus === 'UNREAD' ? 'UNREAD' : null,
      search: search ? search.trim() : null,
      startDate: null,
      endDate: null,
      pageNumber,
      pageLimit,
    }, { headers: this.authHeaders() });
  }

  // Fire-and-forget by design (per the API reference) — callers don't await
  // or check this response; the UI updates optimistically instead.
  markBroadcastRead(broadcastId: number) {
    return this.http.post(`${this.base}/mark/broadcast/read/parent`, { broadcastId }, { headers: this.authHeaders() });
  }
}
